export default __webpack_public_path__ + "static/media/dollar_circle.3cd40456.svg";